<template>
  <div class="customer-service-container">
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <el-button @click="$router.push('/dashboard')" type="primary" plain style="margin-right: 10px;">
            返回首页
          </el-button>
          <span>客服信息设置</span>
          <el-button type="primary" @click="handleAdd">添加客服信息</el-button>
        </div>
      </template>
      
      <el-table :data="customerServiceList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="phone" label="客服电话" width="150" />
        <el-table-column prop="wechat" label="客服微信号" width="150" />
        <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'danger'">
              {{ Number(scope.row.status) === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180" />
        <el-table-column prop="updated_at" label="更新时间" width="180" />
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="scope">
            <el-button type="primary" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button 
              :type="Number(scope.row.status) === 1 ? 'danger' : 'success'" 
              size="small" 
              @click="handleStatusChange(scope.row)"
            >
              {{ Number(scope.row.status) === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog 
      :title="dialogType === 'add' ? '添加客服信息' : '编辑客服信息'" 
      v-model="dialogVisible"
      width="500px"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="客服电话" prop="phone">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="客服微信号" prop="wechat">
          <el-input v-model="form.wechat" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: 'CustomerServiceSettings',
  setup() {
    const loading = ref(false)
    const customerServiceList = ref([])
    const dialogVisible = ref(false)
    const dialogType = ref('add')
    const formRef = ref(null)
    
    const form = ref({
      phone: '',
      wechat: '',
      status: 1
    })
    
    const rules = {
      phone: [{ required: true, message: '请输入客服电话', trigger: 'blur' }],
      wechat: [{ required: true, message: '请输入客服微信号', trigger: 'blur' }]
    }
    
    const fetchCustomerServiceList = async () => {
      loading.value = true
      try {
        const response = await fetch('/api/customer_service_settings.php')
        const data = await response.json()
        if (data.code === 0) {
          customerServiceList.value = data.data
        } else {
          ElMessage.error(data.msg || '获取客服信息列表失败')
        }
      } catch (error) {
        console.error('获取客服信息列表失败:', error)
        ElMessage.error('获取客服信息列表失败')
      } finally {
        loading.value = false
      }
    }
    
    const handleAdd = () => {
      form.value = {
        phone: '',
        wechat: '',
        status: 1
      }
      dialogType.value = 'add'
      dialogVisible.value = true
    }
    
    const handleEdit = (row) => {
      form.value = { ...row }
      dialogType.value = 'edit'
      dialogVisible.value = true
    }
    
    const handleStatusChange = async (row) => {
      try {
        const action = Number(row.status) === 1 ? '禁用' : '启用'
        await ElMessageBox.confirm(`确定要${action}该客服信息吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await fetch('/api/update_customer_service_status.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: row.id,
            status: Number(row.status) === 1 ? 0 : 1
          })
        })
        
        const data = await response.json()
        if (data.code === 0) {
          ElMessage.success(`${action}成功`)
          fetchCustomerServiceList()
        } else {
          ElMessage.error(data.msg || `${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新状态失败:', error)
          ElMessage.error('更新状态失败')
        }
      }
    }
    
    const handleSubmit = async () => {
      if (!formRef.value) return
      
      try {
        await formRef.value.validate()
        
        const url = '/api/customer_service_settings_edit.php'
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(form.value)
        })
        
        const data = await response.json()
        if (data.code === 0) {
          ElMessage.success(dialogType.value === 'add' ? '添加成功' : '更新成功')
          dialogVisible.value = false
          fetchCustomerServiceList()
        } else {
          ElMessage.error(data.msg || (dialogType.value === 'add' ? '添加失败' : '更新失败'))
        }
      } catch (error) {
        console.error('提交失败:', error)
        ElMessage.error('提交失败')
      }
    }
    
    onMounted(() => {
      fetchCustomerServiceList()
    })
    
    return {
      loading,
      customerServiceList,
      dialogVisible,
      dialogType,
      formRef,
      form,
      rules,
      fetchCustomerServiceList,
      handleAdd,
      handleEdit,
      handleStatusChange,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.customer-service-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style> 